import { useState, useEffect } from "react";
import criticalFailure from '../../media/critifcalFailure.png';

function Failure({ message, isNotFullHeight }) {
    const [failureMessage, setFailureMessage] = useState("Something went wrong. Please try again later");

    useEffect(() => {
        if (message && message.length > 3) {
            setFailureMessage(message);
        }
    }, []);

    return (
        <div className={"container has-text-weight-bold is-size-4 has-text-centered hero is-vcentered is-justify-content-center is-flex " + (isNotFullHeight ? "" : "is-fullheight")}>
            <img width="15%" className="is-align-self-center" src={criticalFailure} />
            <div>{failureMessage}</div>
        </div>
    );
}


export default Failure;